const initialState = {
  activeStep: 0,
  steps: {},
  bonus: {},
  save:{
    loading:false,
    error:null,
  },
  checkoutSummary:{
    carrera: null,
    fechaIngreso: null,
    campus: null,
    turno: null,
    precioOriginal: null,
    precioDescuento: null,
    precioComunidad: null,
    descuentoVencimiento: null,
    descuentoPorcentaje: null,
    descuentoId: null,
    error: null,
  },
  knownUser: {
    comunity: false,
    loading: false,
    error: false,
  },
  // Link cifrado de linksEventos (query param "l"): l = blob crudo (viaja a pre-inscripcion),
  // data = { codigo, tipoAsistenteCodigo, tipoAsistenteNombre, valor, fechaVencimiento } resuelto
  // por NBAPI, error = mensaje para el banner si el link es inválido/vencido/sin cupos.
  linkEvento: {
    l: null,
    data: null,
    loading: false,
    error: null,
  },
  homologacion: {
    isValid: null,
    loading: false,
    error: null,
  }
};

const ResponsesReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'SAVE_PREREGISTRATION_REQUEST':
        return {
          ...state,
          save: {
            loading: true,
            error: null,
          },
        };
    case 'SAVE_PREREGISTRATION_SUCCESS':
      return {
        ...state,
        save: {
          loading: false,
          error: null,
        },
      };
    case 'SAVE_PREREGISTRATION_FAIL':
      return {
        ...state,
        save: {
          loading: false,
          error: action.payload,
        },
      };
    case 'SET_STEP_ID':
      const { stepNumber: stepNum, id } = action.payload;
      return {
        ...state,
        steps: {
          ...state.steps,
          [stepNum]: {
            ...state.steps[stepNum],
            id, // Actualizamos el id para el paso específico
            responses: state.steps[stepNum]?.responses || {}, // Mantener las respuestas existentes o inicializar como objeto vacío
          },
        },
      };
    case 'CLEAR_STEPS':
      return {
        ...state,
        steps: {}, // Limpiar todos los pasos
      };
    case 'SAVE_RESPONSES':
      const { stepId, responses } = action.payload;
      const stepKey = Object.keys(state.steps).find(key => state.steps[key].id === stepId);

      if (stepKey) {
        return {
          ...state,
          steps: {
            ...state.steps,
            [stepKey]: {
              ...state.steps[stepKey],
              responses: {
                ...state.steps[stepKey].responses,
                ...responses, // Actualizamos todas las respuestas para el paso específico
              },
            },
          },
        };
      }
      return state;
    case 'LOAD_LINK_EVENTO_REQUEST':
      return { ...state, linkEvento: { l: action.payload, data: null, loading: true, error: null }};
    case 'LOAD_LINK_EVENTO_SUCCESS':
      return { ...state, linkEvento: { ...state.linkEvento, data: action.payload, loading: false, error: null }};
    case 'LOAD_LINK_EVENTO_FAIL':
      // Se descarta también el "l" crudo: un link inválido no debe viajar a la pre-inscripción.
      return { ...state, linkEvento: { l: null, data: null, loading: false, error: action.payload }};
    case 'CLEAR_LINK_EVENTO':
      // La URL no trae "l": limpiar restos persistidos por redux-persist de una visita anterior.
      return { ...state, linkEvento: initialState.linkEvento };
    case 'LOAD_CONOCIOUSUARIO_REQUEST':
      return { ...state, knownUser: { ...state.knownUser, loading: true, error: false }};
    case 'LOAD_CONOCIOUSUARIO_SUCCESS':
      return { ...state, knownUser: { ...state.knownUser, comunity:true ,loading: false, error: false }};
    case 'LOAD_CONOCIOUSUARIO_FAIL':
      return { ...state, knownUser: { ...state.knownUser, comunity:false, loading: false, error: true }};
    case 'SET_BONUS':
      return { ...state, bonus: action.payload};
    case 'SET_CHECKOUT_SUMMARY':
      return {
        ...state,
        checkoutSummary: {
          ...state.checkoutSummary,
          // Un resumen válido nunca conserva el error de un intento anterior (el payload de
          // setCheckoutSummary no trae `error`; el de clearCheckoutSummary sí, en null).
          error: null,
          ...action.payload,
        }
      };
    case 'SET_CHECKOUT_SUMMARY_FAIL':
      return {
        ...state,
        checkoutSummary: {
          ...state.checkoutSummary,
          error: action.payload,
        }
      };
    case 'SET_ACTIVE_STEP':
      return {
        ...state,
        activeStep: action.payload,
      };
    case 'VERIFICAR_HOMOLOGACION_REQUEST':
      return {
        ...state,
        homologacion: {
          ...state.homologacion,
          loading: true,
          error: null,
        },
      };
    case 'VERIFICAR_HOMOLOGACION_SUCCESS':
      return {
        ...state,
        homologacion: {
          ...state.homologacion,
          isValid: action.payload,
          loading: false,
          error: null,
        },
      };
    case 'VERIFICAR_HOMOLOGACION_FAIL':
      return {
        ...state,
        homologacion: {
          ...state.homologacion,
          isValid: false,
          loading: false,
          error: action.payload,
        },
      };
    case 'RESET_RESPONSES':
      return initialState; // Reseteamos todo el estado
    default:
      return state;
  }
};

export default ResponsesReducer;
